import { render, staticRenderFns } from "./ClientesForm.vue?vue&type=template&id=aa6cc0f0&scoped=true&lang=pug&"
import script from "./ClientesForm.vue?vue&type=script&lang=js&"
export * from "./ClientesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6cc0f0",
  null
  
)

export default component.exports